
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { getMasterData } from './actions/ManageClaimActions';
import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import { renderTextArea, renderTextField, renderAutoCompleteSingleSelect} from '../../../../components/reduxFields';
import { saveBatchUpdateReasonCode } from './actions/ManageClaimActions';
import SmallLoader from './../../../../img/small-loader.gif';

const validate = (values) => {
    const errors = {};

    if (!values.title) {
        errors.title = 'Please enter note title'
    }
    // if (!values.notes) {
    //     errors.notes = 'Please enter notes'
    // }
    return errors;
};


class UpdateReasonCodeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claimId: props.claimId ? props.claimId : null,
            noteId: null,
            reasonCodeList:null,
            textAreaLength:0,
            reasonCodeId : null,
            reasonCodeLabel:null
        }
    }

    componentWillMount() {
        let masterData = {'masterdata' : 'evvreasoncodes'}
        this.props.getMasterData(masterData);
        if(this.props.master_data){
            this.setState({
               reasonCodeList: this.props.master_data.evvReasonCodes
            })  
       }
    }


    componentWillReceiveProps (nextProps) {
        if(nextProps.master_data){
             this.setState({
                reasonCodeList: nextProps.master_data.evvReasonCodes
             })  
        }
    }

    componentWillUnmount(){
        this.props.loadData();
    }

    handleTextAreaInput  = (e)=>{
      this.setState({textAreaLength:e.target.value.length})
    }

    handleClose = () => {
        this.props.closeDialog();
    }

   
    handleReasonCodeSelection = (input,selected)=>{
        input.onChange(selected.value)
        this.setState({
            reasonCodeId : selected.value,
            reasonCodeLabel: selected.label
        })
    }

    onSubmitHandler= async(formProps) =>{
        let postData = {
            "claimIds": this.props.claimIds,
            "reasonCode": this.state.reasonCodeLabel,
            "note": formProps.notes,
            "ReasonCodeId" : this.state.reasonCodeId,
            }
         
         try {
            await this.props.saveBatchUpdateReasonCode(postData.claimIds, postData.reasonCode,postData.note, postData.ReasonCodeId);
            this.props.getAllEVVClaims(); // Reload data after saving
            } catch (error) {
                console.error("Error saving reason code details:", error); // Reference the error correctly
            }
         this.props.closeDialog();
        }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
      
        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title='BULK ADD REASON CODE'
                    modal={false}
                    open={true}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" >
                                <div className="row">
                                    <div className="col-sm-12 require mt-30">
                                        <Field
                                            name="ReasonCodeList"
                                            label="Reason Code"
                                            options = {this.state.reasonCodeList}
                                            handleNewRequest = {this.handleReasonCodeSelection}
                                            component={renderAutoCompleteSingleSelect} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 mt-30">
                                        <Field
                                            name="notes"
                                            label="Note"
                                            type="text"
                                            maxLength="1000"
                                            onChange={(e)=>this.handleTextAreaInput(e)}
                                            component={renderTextArea} />
                                        <span>
                                            <strong>{`${1000 - this.state.textAreaLength} Characters Remaining`}</strong>
                                        </span> 
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 pt20 btn_rt">
                                        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
                                        <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        master_data: state.billing.master_data

    };
};

UpdateReasonCodeModal = reduxForm({
    form: 'UpdateReasonCodeModal', // a unique identifier for this form
    validate,
})(UpdateReasonCodeModal);

export default connect(mapStateToProps, { saveBatchUpdateReasonCode, getMasterData })(UpdateReasonCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/UpdateReasonCodeModal.js